import React                          from 'react';

import PriceMatrix                from 'pu-react/components/PriceMatrix';
import MobilePriceMatrix          from './MobilePriceMatrix';
import PriceMatrixHead            from '../PriceMatrixHead';
import CustomPriceMatrixCell      from '../CustomPriceMatrixCell';

import { is_express }             from '../PriceMatrixHead';

const MobilePrice = (props) => {
  if (!props.quote || !props.quote.line_items || !props.quote.line_items.length) {
    return null;
  }

  const lineItem = props.quote.line_items[0]
  const { 
    lead_times,
    restricted_price 
  } = lineItem

  const prototype_lead_times = lead_times.filter(leadTime => is_express(leadTime) )
  const production_lead_times = lead_times.filter(leadTime => !is_express(leadTime) )

  return (
    <React.Fragment>
      <MobilePriceMatrix
      lineItem={lineItem}
      supplier={lineItem.product_key}
      restricted_price={restricted_price}
      parametersChanged={props.parametersChanged}
      prefix_name={`items[${props.itemId}]`}
      rowSelected={props.parameters.row_selected}
      showSummary={props.showSummary}
      groupName="prices"
      leadTimes={prototype_lead_times}
      matrixClass="table-prototype"
      matrixHead={PriceMatrixHead}
      matrixCell={CustomPriceMatrixCell}
      {...props} />
      <MobilePriceMatrix
      lineItem={lineItem}
      supplier={lineItem.product_key}
      restricted_price={restricted_price}
      parametersChanged={props.parametersChanged}
      prefix_name={`items[${props.itemId}]`}
      rowSelected={props.parameters.row_selected}
      showSummary={props.showSummary}
      groupName="prices"
      leadTimes={production_lead_times}
      matrixHead={PriceMatrixHead}
      matrixCell={CustomPriceMatrixCell}
      {...props} />
    </React.Fragment>
  )

}

export default MobilePrice;

